import { useEffect } from 'react';
import styles from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import EcoImg from 'eco-design/base/eco-img';
import { getIsPadWidth } from 'eco-design-micro/utils-base/devices';

export default function ProductAnimation() {
    const { useLang } = useGlobal();
    const { t } = useLang('PoweroceanPlus.ProductAnimation');
    let innerHeight = 1080;
    if (typeof window !== 'undefined') {
        innerHeight = window?.innerHeight;
    }
    const isMobile = getIsPadWidth();

    useEffect(() => {
        const AniContainer = window?.AniContainer;
        AniContainer.create({
            syncFromTo: [['.product-animation .product-title', { opacity: 1 }, { opacity: 0 }]],
            triggerElement: '.product-animation',
            triggerHook: 1,
            offset: '110%',
            duration: '10%',
            scrollUpdatePos: true,
        });
        AniContainer.create({
            syncFromTo: [['.product-animation .bg-img', { scale: 4 }, { scale: 1 }]],
            triggerElement: '.product-animation',
            triggerHook: 1,
            offset: '130%',
            duration: '50%',
            scrollUpdatePos: true,
        });
        AniContainer.create({
            syncFromTo: [['.product-animation .solution-item', { opacity: 0 }, { opacity: 1 }]],
            triggerElement: '.product-animation',
            triggerHook: 1,
            offset: '180%',
            duration: '50%',
            scrollUpdatePos: true,
        });
    }, []);

    return (
        <div className={`${styles.productAnimation} product-animation`} style={{ height: innerHeight * (isMobile ? 2 : 3) }}>
            <div className="sticky">
                <div className="img-box">
                    <div className="bg-img">
                        <EcoImg
                            pc="https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718698350007/pc1.jpg"
                            pad="https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718699081536/mo.jpg"
                            alt={t('title')}
                        />
                    </div>
                </div>
                <div className="product-title">{t('product')}</div>
                <div className="solution-item">
                    <div className="text-box">
                        <div className="sub-title">{t('label')}</div>
                        <h2 className="title">{t('title')}</h2>
                        <div className="desc">{t('desc')}</div>
                        <div className="worp">
                            <h3 className="worp-item">
                                <span className="item-title first-item-title">{t('item_title1')}</span>
                                <span className="item-desc">{t('item_desc1')}</span>
                            </h3>
                            <h3 className="worp-item">
                                <span className="item-title">{t('item_title2')}</span>
                                <span className="item-desc">{t('item_desc2')}</span>
                            </h3>
                        </div>
                    </div>
                    <div className="bg-img">
                        <EcoImg
                            pc="https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718361595770/pc-tuya.jpg"
                            pad="https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718361588246/mo-tuya.jpg"
                            alt={t('title')}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}

export const getStaticProps = async () => {
    return {
        props: {},
    };
};
